import api from './';

export default {
  /**
   * @param {string} email
   * @param {string} password
   * @return {Promise<{ checkPhoneCode: boolean }>}
   */
  login: (email, password) => api.post('login', { json: { username: email, password } }).json(),
  checkIfEmailExists: (email) => api.get('check-email-exists', { searchParams: new URLSearchParams({ username: email }) }),
  /**
   * @param {{
   *    civility: string,
   *    username: string,
   *    password: string,
   *    mobile: string,
   *    firstname: string,
   *    lastname: string
   *    birthdate: string,
   *    ssid: string,
   *    code: string,
   *    acceptEmailCommunication: boolean,
   *    timezone: string,
   * }} payload
   */
  register: (payload) => api.post('users', {
    json: {
      ...payload,
      ssid: payload.ssid?.replace(/\s+/g, ''),
      mobile: payload.mobile.replace(/\s+/g, ''),
    },
  }),
  sendCode: (phoneNumber) => {
    const searchParams = new URLSearchParams({ mobile_phone: phoneNumber.replace(/\s+/g, '') });
    return api.post('send-code', { searchParams }).json();
  },
  verifyAuthCode: (code, saveMFA) => api.post('verify_sms_code', { json: { code, save_mfa: saveMFA } }),
  recoverPassword: (email) => api.post('recovery', { json: { username: email } }),
  resetPassword: (token, newPassword) => api.post('reset_password', {
    json: {
      resetPasswordToken: token,
      password: newPassword,
    },
  }),
};
